import React, { Component } from 'react'
import Link from 'gatsby-link'
import LogoSVG from './_images/logo.svg'
import MarginContainer from '../shared/MarginContainer'
import styled from 'styled-components'
import * as colors from '../../theme/colors'
import Cookies from 'js-cookie'

const Gdpr = styled.section`
  background-color: ${colors.darkBlue};
  padding: 15px 20px;
  font-weight: 500;
  color: #fff;
  text-align: center;
  font-size: 16px;
  
  .close {
    font-size: 20px;
    font-weight: 200;
    border: 0;
    background-color: transparent;
    color: #fff;
    cursor: pointer;
    position: relative;
    top: 3px;
    font-family: faktumExtraBold;
  }
`

class GdprBanner extends Component{

  COOKIE_BANNER = "GDPR_BANNER"

  state = {
    displayGdpr: "true"
  }

  componentWillMount(){
    let displayBanner = Cookies.get(this.COOKIE_BANNER);
    this.setState({displayGdpr: displayBanner || "true"})
  }

  _handleBannerDiscard(){
    this.setState({displayGdpr: !this.state.displayGdpr})
    Cookies.set(this.COOKIE_BANNER, !this.state.displayGdpr , { expires: 7 });
  }

  render() {
    return (
      <span>
        {
          this.state.displayGdpr === "true" ?
          <Gdpr>By continuing to use this site you consent to the use of cookies in accordance with our <a href="https://docs.squadlytics.io/privacy-policy/
"> cookie policy</a><button className="close" onClick={() => this._handleBannerDiscard() }>X</button></Gdpr> : <span></span>
        }
      </span>
    )
  }
}


const Header = () => (
  <GdprBanner />
)

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/index.js